import React, { useEffect, useMemo, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "../../Home/Hospitality/Hospitality.css";
import "./SolutionDetailsApplications.css";

import img1 from "../../../../assets/images/home/hospitality/c1.jpg";
import img2 from "../../../../assets/images/home/hospitality/c2.jpg";
import img3 from "../../../../assets/images/home/hospitality/c3.jpg";
import img4 from "../../../../assets/images/home/hospitality/c4.png";
import { resolveMediaUrl } from "../../../../utils/media";
import { getPublicSectors } from "../../../../api/sectors";

const SolutionDetailsApplications = ({ solution }) => {
  const { i18n } = useTranslation();
  const sliderRef = useRef(null);
  const [apiSectors, setApiSectors] = useState([]);
  const dragStateRef = useRef({
    isMouseDown: false,
    isDragging: false,
    startX: 0,
    startScrollLeft: 0,
  });

  const sectorsFallback = [
    { title: "COMMERCIAL", image: img1, slug: "commercial" },
    { title: "RESIDENTIAL", image: img2, slug: "residential" },
    { title: "ENTERTAINMENT", image: img3, slug: "entertainment" },
    { title: "HOSPITALITY", image: img4, slug: "hospitality" },
    { title: "COMMERCIAL", image: img1, slug: "commercial" },
    { title: "RESIDENTIAL", image: img2, slug: "residential" },
    { title: "ENTERTAINMENT", image: img3, slug: "entertainment" },
  ];

  useEffect(() => {
    let isMounted = true;
    const load = async () => {
      try {
        const data = await getPublicSectors(String(i18n.language || "en").toLowerCase());
        if (!isMounted) return;
        setApiSectors(Array.isArray(data) ? data : []);
      } catch {
        if (isMounted) setApiSectors([]);
      }
    };
    load();
    return () => {
      isMounted = false;
    };
  }, [i18n.language]);

  const sectors = useMemo(() => {
    if (!Array.isArray(apiSectors) || !apiSectors.length) return sectorsFallback;
    const mapped = apiSectors
      .map((sector, idx) => {
        const slug = String(sector?.slug || "").trim();
        if (!slug) return null;
        return {
          title: sector?.title || slug.toUpperCase(),
          slug,
          image:
            resolveMediaUrl(sector?.image || sector?.imageUrl || sector?.mediaUrl) ||
            sectorsFallback[idx % sectorsFallback.length]?.image,
        };
      })
      .filter(Boolean);
    return mapped.length ? mapped : sectorsFallback;
  }, [apiSectors]);

  const handleMouseDown = (e) => {
    if (!sliderRef.current) return;

    dragStateRef.current.isMouseDown = true;
    dragStateRef.current.isDragging = false;
    dragStateRef.current.startX = e.clientX;
    dragStateRef.current.startScrollLeft = sliderRef.current.scrollLeft;

    sliderRef.current.classList.add("is-dragging");
  };

  const stopDragging = () => {
    if (!sliderRef.current) return;
    dragStateRef.current.isMouseDown = false;
    dragStateRef.current.isDragging = false;
    sliderRef.current.classList.remove("is-dragging");
  };

  const handleMouseMove = (e) => {
    if (!sliderRef.current || !dragStateRef.current.isMouseDown) return;
    const delta = e.clientX - dragStateRef.current.startX;
    if (Math.abs(delta) > 10) {
      dragStateRef.current.isDragging = true;
    }
    if (!dragStateRef.current.isDragging) return;
    e.preventDefault();
    const walk = delta * 1.2;
    sliderRef.current.scrollLeft = dragStateRef.current.startScrollLeft - walk;
  };

  return (
    <section className="hospitality solutionDetailsApplications">
      <div className="hospitality-container">
        <span className="hospitality-tag tag">{solution?.applicationsTag || "APPLICATIONS"}</span>

        <h2>
          {solution?.applicationsTitle || "Typical"} <span>{solution?.applicationsTitleAccent || "Applications"}</span>
        </h2>

        <div
          className="hospitality-slider"
          ref={sliderRef}
          onMouseDown={handleMouseDown}
          onMouseMove={handleMouseMove}
          onMouseUp={stopDragging}
          onMouseLeave={stopDragging}
        >
          {sectors.map((item, index) => (
            <Link
              to={`/sectors/${item.slug}`}
              className="hospitality-card hospitality-cardLink"
              key={`${item.slug}-${index}`}
              onClick={(e) => {
                if (dragStateRef.current.isDragging) e.preventDefault();
              }}
            >
              <div className="hospitality-image">
                <img src={item.image} alt={item.title} />
              </div>

              <h3>{item.title}</h3>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SolutionDetailsApplications;
